/* eslint-disable complexity */
/* eslint-disable react/sort-comp */
import { Component } from 'react'
import PropTypes from 'prop-types'
import { UPDATE_CART_SUMMARY } from 'shared/constants'
import * as blUrls from 'lib/urls'
import { Modal, ModalBody } from 'components/modal'
import { InfoButton } from 'components/buttons'
import Quantity from 'components/quantity'
import GiftCardForm from 'store/components/forms/gift-card-form'
import CrowdfundForm from 'store/components/forms/crowdfund-form'
import { parseErrorMessage } from 'lib/api-utils'
import { track, tracking } from 'lib/analytics'
import { errorMessage, successMessage } from 'lib/flash-message'
import BabyUIThemeProvider from 'baby-ui/foundation/BabyUIThemeProvider'
import {
  getSearchId,
  PRODUCT_SEARCH_INDEX_KEY,
} from 'shared/hooks/useSearchId/useSearchId'
import onCurrentUserExternalLogin from 'shared/utils/onCurrentUserExternalLogin/onCurrentUserExternalLogin'
import { RegItemAddSuccessModal } from './reg-item-add-success-modal'
import { gtagEvents } from '../helpers'
import { getCollaboratorRole } from '../../../../utils'
import GetPumpThroughInsuranceCTA from '../../GetPumpThroughInsuranceCTA/GetPumpThroughInsuranceCTA'
import GetYourPumpTheme from '../../themes/GetYourPumpThroughInsuranceTheme'
import GetPumpThroughInsuranceModal from '../../GetPumpThroughInsuranceModal/GetPumpThroughInsuranceModal'
import { BLHealthModal } from '../../GetPumpThroughInsuranceModal/BLHealthModal'
import { getCurrentUser } from '../../../../shared/utils/getCurrentUser/getCurrentUser'
import { getSearchPreviewIds } from 'components/global-nav/components/SearchBar/SearchBar.utils'

// we want to not show add to cart/in stock for these products
// because we don't actually sell them :D
// We already mute these CTAs for universal products, but huggies
// asked us to remove them completely for these products.
// Ideally this logic lives outside of this component which
// would work with the add to cart CTA, but the in stock notification
// visible state is managed internally. Opting to handle both
// internally for huggies since I'm on a tight deadline.
export const huggiesDiaperCalculatorProductIds = [745137, 745216]

const theme = new GetYourPumpTheme()

// define context of any sub tracking event
@tracking(({ product }, state) => ({ product }))
class ProductActionsBase extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addingInStockNotification: false,
      addingToCart: false,
      addingToRegistry: false,
      quantity: 1,
      showAddGiftCardModal: false,
      showAddCrowdfundModal: false,
      showRecommendation: false,
      isFirstRegItem: false,
      breastPumpModal: { name: null, open: false },
    }
  }

  handleChangeQuantity = (quantity) => {
    this.setState({ quantity })
  }

  handleAddToRegistry = () => {
    const { showBreastPumpCta } = this.props

    if (showBreastPumpCta) {
      this.openGetYourPumpModal(BLHealthModal.AddToRegistry)
    } else {
      this.processAddToRegistry()
    }
  }

  handleAddToCart = () => {
    const { showBreastPumpCta } = this.props

    if (showBreastPumpCta) {
      this.openGetYourPumpModal(BLHealthModal.AddToCart)
    } else {
      this.processAddToCart()
    }
  }

  handleModalAction = () => {
    this.closeGetYourPumpModal()
    const { breastPumpModal } = this.state

    if (breastPumpModal.name === BLHealthModal.AddToCart) {
      this.processAddToCart()
      return
    }

    if (breastPumpModal.name === BLHealthModal.AddToRegistry) {
      this.processAddToRegistry()
    }
  }

  processAddToRegistry = () => {
    const { currentUser } = this.props

    if (currentUser) {
      this.addToRegistry()
    } else {
      window.open(blUrls.loginPathAsPopup, '_blank')

      onCurrentUserExternalLogin(this.addToRegistry)
    }
  }

  openGetYourPumpModal = (modal) => {
    this.setState((prevState) => ({
      ...prevState,
      breastPumpModal: { name: modal, open: true },
    }))
  }

  closeGetYourPumpModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      breastPumpModal: { name: null, open: false },
    }))
  }

  processAddToCart = () => {
    const { addToCart, product, PubSub } = this.props
    const { quantity } = this.state
    this.setState({ addingToCart: true }, () => {
      if (product.isGiftCard) {
        this.showAddGiftCardModal()
      } else {
        const cartItemQuantity = quantity
        const cartItemProduct = product
        addToCart({
          productId: cartItemProduct.id,
          quantity: cartItemQuantity,
        })
          .then((resp) => {
            // tracking
            this.trackAddToCart({
              product: cartItemProduct,
              quantity: cartItemQuantity,
            })
            this.setState({ addingToCart: false })
            PubSub.publish(UPDATE_CART_SUMMARY, {
              showCartDropdown: true,
              animateBadge: true,
            })
          })
          .catch((resp) => {
            this.setState({ addingToCart: false })
            errorMessage(parseErrorMessage(resp))
          })
      }
    })
  }

  handleAddGiftCardToCart = (data) => {
    const { addToCart, product, PubSub } = this.props
    const { amount: price, productId, quantity, regItemId } = data
    return addToCart({ productId, price, quantity, regItemId }).then((resp) => {
      // tracking
      this.trackAddToCart({ product, quantity, price })
      this.setState({ addingToCart: false })
      if (regItemId) {
        // Return a new promise so that redux-form does not toggle submitting before window.location is changed
        // eslint-disable-next-line no-return-assign
        return new Promise(() => (window.location = blUrls.checkoutPath))
      }
      this.hideAddGiftCardModal()
      PubSub.publish(UPDATE_CART_SUMMARY, {
        showCartDropdown: true,
        animateBadge: true,
      })
    })
  }

  addToRegistry = () => {
    const { product } = this.props
    if (product.isCrowdfund) {
      this.addCrowdfundToRegistry()
    } else {
      this.addProductToRegistry()
    }
  }

  addCrowdfundToRegistry = () => {
    this.setState({ showAddCrowdfundModal: true })
  }

  handleNotifyInStock = () => {
    const { addProductAvailabilitySubscription } = this.props
    this.setState({ addingInStockNotification: true })
    addProductAvailabilitySubscription().then(() =>
      this.setState({ addingInStockNotification: false })
    )
  }

  hideAddCrowdfundModal = () => {
    this.setState({
      showAddCrowdfundModal: false,
      addingToCart: false,
    })
  }

  setIdleState = () => {
    this.setState({
      showRecommendation: false, // eslint-disable-next-line react/no-unused-state
      nextRecommendation: null,
    })
  }

  // if method return a promise, tracking will happens after promise is resolved
  // https://github.com/nytimes/react-tracking#advanced-usage
  @tracking((props, state, [{ product, quantity }], [_, giftCardPrice]) => {
    const newCartItem = { product, quantity, giftCardPrice }
    const searchId = getSearchId(PRODUCT_SEARCH_INDEX_KEY)
    const searchPreviewIds = getSearchPreviewIds()
    return {
      event: track.addedToCart,
      cartTypes: [track.CartTypes.STORE],
      cartStores: [track.CartStores.BABYLIST_STORE],
      isFsaHsaEligible: props.product?.fsaHsaEligible,
      storeAdded: track.StoreAdded.BABYLIST,
      newCartItem,
      eventType: track.EventType.ADDED_TO_STORE,
      searchId,
      searchPreviewIds,
      subscribeToMarketingEmail: props.subscribeToMarketingEmail === true,
    }
  })
  trackAddToCart = ({ product, quantity }) => {
    const { activeCategory } = this.props
    ga('send', 'event', {
      eventCategory: 'Button',
      eventAction: 'Click',
      eventLabel: 'addToCart',
      eventValue: product.price.current,
    })
    gtagEvents.confirmConversion()

    // track add to cart for lookalike audience targeting
    // content_ids and content_type required for dynamic ads
    // https://developers.facebook.com/docs/facebook-pixel/reference/
    // https://developers.facebook.com/docs/facebook-pixel/implementation/dynamic-ads
    fbq('track', 'AddToCart', {
      content_type: 'product',
      content_ids: [product.id],
    })

    if (window && window.pintrk) {
      pintrk('track', 'AddToCart', {
        product_id: product.id,
        order_quantity: quantity,
        line_items: [
          {
            product_id: product.id,
            product_name: product.name,
            product_category: activeCategory?.title,
            product_price: Number(product.price.current).toFixed(2),
          },
        ],
      })
    }
  }

  showAddGiftCardModal = () => {
    this.setState({ showAddGiftCardModal: true })
  }

  hideAddGiftCardModal = () => {
    this.setState({
      showAddGiftCardModal: false,
      addingToCart: false,
    })
  }

  // if method return a promise, tracking will happens after promise is resolved
  // https://github.com/nytimes/react-tracking#advanced-usage
  @tracking(
    (
      { product, regItemsCount, currentUser },
      { isFirstRegItem },
      methodArgs,
      [{ regItem }, err]
    ) => {
      if (!regItem) return

      const searchId = getSearchId(PRODUCT_SEARCH_INDEX_KEY)
      const searchPreviewIds = getSearchPreviewIds()
      return {
        event: track.addedToRegistry,
        collaboratorRole: getCollaboratorRole(currentUser),
        isFirstRegItem,
        isFsaHsaEligible: product?.fsaHsaEligible,
        regItem,
        searchId,
        searchPreviewIds,
        email: currentUser?.email,
        userId: currentUser?.id,
      }
    }
  )
  addProductToRegistry() {
    const { addToRegistry } = this.props
    const currentUser = getCurrentUser()
    const { quantity } = this.state
    const setStateAsync = (updater) =>
      new Promise((resolve) => this.setState(updater, resolve))
    return setStateAsync({ addingToRegistry: true })
      .then(() =>
        addToRegistry(
          {
            quantity,
          },
          {
            // enable for signed in useres w/ registry
            includeRecommendation: currentUser,
          }
        )
      )
      .then((resp) => {
        const title = resp?.regItem?.title
        const registryLink = `<a href="${blUrls.registryPath(
          currentUser.currentRegistry.urlSlug
        )}">${currentUser.currentRegistry.title || 'your registry'}</a>!`

        const successMessageText = `${title || 'Item'} added to ${registryLink}`
        if (resp?.regItem?.addNextRecommendation) {
          const showRecommendation =
            resp?.regItem?.addNextRecommendation.recommendedProducts.length >= 5
          this.setState({
            showRecommendation,
            addingToRegistry: false,
            addNextRecommendation: resp.regItem.addNextRecommendation,
          })

          if (!showRecommendation) {
            successMessage(successMessageText)
          }
        } else {
          this.setState({ addingToRegistry: false })
          successMessage(successMessageText)
        }
        this.setState((state) => ({
          ...state,
          isFirstRegItem: resp.regItem.isFirstRegItem,
        }))
        return resp
      })
      .catch((resp) => {
        this.setState({ addingToRegistry: false })
        errorMessage()
      })
  }

  fireHealthBannerClickedEvent = (eventLocation, eventCta) => {
    track.healthBannerClicked({
      eventLocation,
      eventCta,
    })
  }

  fireHealthBannerViewedEvent = (eventLocation) => {
    track.healthBannerViewed({
      eventLocation,
    })
  }

  getModalEventLocation = () => {
    const { breastPumpModal } = this.state
    return breastPumpModal.name === BLHealthModal.AddToCart
      ? track.EventLocation.PDP_MINUS_ADD_TO_CART
      : track.EventLocation.PDP_MINUS_ADD_TO_BABYLIST
  }

  render() {
    const {
      addedToRegistry,
      addedToCart,
      addToRegistry,
      cashFundPreferences,
      currentUser,
      isRegistryOwner,
      product,
      showAddToCartButton: initialShowAddToCartButton,
      regItemId,
      registryId,
      saveCashFundPreferences,
      showBreastPumpCta,
    } = this.props

    const showAddToCartButton =
      initialShowAddToCartButton &&
      !huggiesDiaperCalculatorProductIds.includes(product.id)

    const {
      addingToCart,
      addingToRegistry,
      addNextRecommendation,
      quantity,
      showAddCrowdfundModal,
      showAddGiftCardModal,
      showRecommendation,
      breastPumpModal,
    } = this.state

    // Hide Add To Babylist if a Guest is navigating from a registrant's registry
    const showAddToBabylist = !(regItemId && registryId)

    const showQuantitySelector =
      !product.isGiftCard &&
      !product.isCashFund &&
      !product.isCrowdfund &&
      (showAddToBabylist || showAddToCartButton)

    const quantityLimit = product.purchaseQuantityLimit
    const showQuantityLimit = product.showPurchaseQuantityLimit

    return (
      <BabyUIThemeProvider theme={theme}>
        <div>
          <GetPumpThroughInsuranceModal
            modal={breastPumpModal.name}
            open={breastPumpModal.open}
            onClick={(ctaText) => {
              const eventLocation = this.getModalEventLocation()
              this.fireHealthBannerClickedEvent(eventLocation, ctaText)
            }}
            onClose={this.closeGetYourPumpModal}
            onProceedWithAction={this.handleModalAction}
            onView={() => {
              const eventLocation = this.getModalEventLocation()
              this.fireHealthBannerViewedEvent(eventLocation)
            }}
          />

          {showQuantitySelector && (
            <Quantity
              className="mtm mbl"
              limit={showQuantityLimit ? quantityLimit : null}
              max={quantityLimit}
              min={1}
              value={quantity}
              onChange={this.handleChangeQuantity}
            />
          )}

          {showBreastPumpCta && (
            <GetPumpThroughInsuranceCTA
              onClick={() => {
                this.fireHealthBannerClickedEvent(track.EventLocation.PDP, '')
              }}
              onView={() =>
                this.fireHealthBannerViewedEvent(track.EventLocation.PDP)
              }
            />
          )}

          {showAddToBabylist && (
            <InfoButton
              block
              className="mbm"
              disabled={addingToRegistry}
              empty={regItemId && registryId}
              submitting={addingToRegistry}
              onClick={this.handleAddToRegistry}
            >
              {addedToRegistry ? '✓ Added!' : 'Add to Babylist'}
            </InfoButton>
          )}

          <RegItemAddSuccessModal
            addNextRecommendation={addNextRecommendation}
            show={showRecommendation}
            onHide={this.setIdleState}
          />

          {showAddToCartButton ? (
            <InfoButton
              block
              empty
              className="mbm"
              disabled={!product.availableOnBabylist || addingToCart}
              rel="nofollow"
              submitting={addingToCart}
              onClick={this.handleAddToCart}
            >
              {addedToCart ? '✓ Added!' : 'Add to Cart'}
            </InfoButton>
          ) : null}

          <Modal
            show={showAddGiftCardModal}
            title={regItemId ? 'Buy Gift Card' : 'Add Gift Card'}
            onHide={this.hideAddGiftCardModal}
          >
            <ModalBody>
              <GiftCardForm
                giftCardOptions={product.giftCardOptions}
                regItemId={regItemId}
                submitText={regItemId ? 'Buy Now' : null}
                onCancel={this.hideAddGiftCardModal}
                onSubmit={this.handleAddGiftCardToCart}
              />
            </ModalBody>
          </Modal>

          <Modal
            show={showAddCrowdfundModal}
            title="Add a Cash Fund"
            onHide={this.hideAddCrowdfundModal}
          >
            <ModalBody>
              <CrowdfundForm
                cashFundPreferences={cashFundPreferences}
                currentRegistryTitle={currentUser?.currentRegistry?.title}
                currentRegistryUrlSlug={currentUser?.currentRegistry?.urlSlug}
                imageUrl={product.images[0].thumbnailUrl}
                isRegistryOwner={isRegistryOwner}
                title={product.name}
                onHide={this.hideAddCrowdfundModal}
                onSaveCashFundPreferences={saveCashFundPreferences}
                onSubmit={addToRegistry}
              />
            </ModalBody>
          </Modal>
        </div>
      </BabyUIThemeProvider>
    )
  }
}

export const ProductActions = ProductActionsBase

ProductActionsBase.propTypes = {
  activeCategory: PropTypes.object,
  addProductAvailabilitySubscription: PropTypes.func.isRequired,
  addedToRegistry: PropTypes.bool,
  addedToCart: PropTypes.bool,
  addToRegistry: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  cashFundPreferences: PropTypes.object,
  currentUser: PropTypes.object,
  isRegistryOwner: PropTypes.bool,
  product: PropTypes.object.isRequired,
  PubSub: PropTypes.shape({
    publish: PropTypes.func.isRequired,
  }).isRequired,
  registryId: PropTypes.number,
  regItemId: PropTypes.number,
  saveCashFundPreferences: PropTypes.func.isRequired, // eslint-disable-next-line react/no-unused-prop-types
  showAddToCartButton: PropTypes.bool,
  userEmail: PropTypes.string,
  showBreastPumpCta: PropTypes.bool,
}

ProductActionsBase.defaultProps = {
  showBreastPumpCta: false,
  activeCategory: undefined,
  addedToRegistry: false,
  addedToCart: false,
  cashFundPreferences: undefined,
  currentUser: undefined,
  isRegistryOwner: false,
  registryId: undefined,
  regItemId: undefined,
  showAddToCartButton: true,
  userEmail: undefined,
}
